import React, { useContext } from 'react';
import { Button, Tag } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { ThemeContext } from '../../contexts/ThemeContext';

export interface IActiveFilterItem {
    key: string;
    label: string;
    value: React.ReactNode;
    onClear?: () => void;
    onRemove?: () => void;
}

export interface IActiveFiltersBarProps {
    filters: Array<IActiveFilterItem | null | undefined | false>;
    onClearAll: () => void;
    title?: string;
    clearAllText?: string;
    style?: React.CSSProperties;
}

export default function ActiveFiltersBar({
    filters,
    onClearAll,
    title = 'Filtros ativos:',
    clearAllText = 'Limpar todos',
    style,
}: IActiveFiltersBarProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const validFilters = filters.filter((f): f is IActiveFilterItem => Boolean(f && f.value));

    if (validFilters.length === 0) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 14px',
                borderRadius: 10,
                background: isDark ? 'rgba(255, 255, 255, 0.04)' : '#f8fafc',
                border: `1px solid ${isDark ? '#262626' : '#eaedf1'}`,
                fontSize: 13,
                gap: 12,
                flexWrap: 'wrap',
                ...style,
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <FilterOutlined style={{ color: '#1677ff', fontSize: 14 }} />
                <span style={{ fontWeight: 600, color: isDark ? '#d4d4d4' : '#475569' }}>
                    {title}
                </span>
                {validFilters.map((filter) => (
                    <Tag
                        key={filter.key}
                        closable
                        onClose={(e) => {
                            e.preventDefault();
                            if (filter.onClear) filter.onClear();
                            else if (filter.onRemove) filter.onRemove();
                        }} style={{ margin: 0, borderRadius: 6, fontSize: 12 }}
                    >
                        {filter.label}: {filter.value}
                    </Tag>
                ))}
            </div>

            <Button
                type="link"
                size="small"
                onClick={onClearAll}
                style={{ color: '#1677ff', fontWeight: 600, padding: 0 }}
            >
                {clearAllText}
            </Button>
        </div>
    );
}
